import axios from "axios";

const state = {
 
};

const getters = {
};

const actions = {
  
  async stripePaymentIntentAction({ commit }, payload) {
    let stringPayload = JSON.stringify(payload);
    const params = new URLSearchParams();
    params.append("params", stringPayload);
    const response = await axios.post("stripe-payment-intent", params);
    return response.data;
  },
  async accountPaymentIntentAction({ commit }, payload) {
    let stringPayload = JSON.stringify(payload);
    const params = new URLSearchParams();
    params.append("params", stringPayload);
    const response = await axios.post("account-payment-intent", params);
    return response.data;
  },
  async paymentsHistory({ commit }, payload) {
    let stringPayload = JSON.stringify(payload);
    const params = new URLSearchParams();
    params.append("params", stringPayload);
    const response = await axios.post("get-payments-history", params);
    return response.data;
  },
  async getSavedPaymentMethods({ commit }, payload) {
    let stringPayload = JSON.stringify(payload);
    const params = new URLSearchParams();
    params.append("params", stringPayload);
    const response = await axios.post("get-saved-payment-methods", params);
    return response.data;
  },
  
  async stripeConfirmCardPayment({ commit }, payload) {
    let stringPayload = JSON.stringify(payload);
    const params = new URLSearchParams();
    params.append("params", stringPayload);
    const response = await axios.post("stripe-confirm-card-payment", params);
    return response.data;
  },

  async removeSourceAction({commit},payload) {
    let stringPayload = JSON.stringify(payload);
    const params = new URLSearchParams();
    params.append("params", stringPayload);
    const response = await axios.post("remove-payment-source", params);
    return response.data;
  },
  async setDefaultSourceAction({commit},payload) {
    let stringPayload = JSON.stringify(payload);
    const params = new URLSearchParams();
    params.append("params", stringPayload);
    const response = await axios.post("set-default-stripe-source", params);
    return response.data;
  },

  async updateCardDetailsAction({commit},payload){
    let stringPayload = JSON.stringify(payload);
    const params = new URLSearchParams();
    params.append("params", stringPayload);
    const response = await axios.post("update-stripe-card", params);
    return response.data;
  },

  async stripeCardSetupIntentAction({commit},payload){
    let stringPayload = JSON.stringify(payload);
    const params = new URLSearchParams();
    params.append("params", stringPayload);
    const response = await axios.post("stripe-card-setup-intent", params);
    return response.data;
  }
 
};

const mutations = {
  
};

export default {
  state,
  getters,
  actions,
  mutations,
};
